var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpenEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.04167,
    y: 1.04167,
    width: 22.9167,
    height: 22.9167,
    rx: 4.51389,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.04167,
    y: 1.04167,
    width: 22.9167,
    height: 22.9167,
    rx: 4.51389,
    stroke: "#FF8027",
    strokeWidth: 2.08333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91943 5.22217V19.1111H17.4133V5.22217H6.91943ZM16.5645 18.1851H7.7682V6.07093H16.5645V18.1851Z",
    fill: "#FF8027"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 1,
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenEventIcon);
export default __webpack_public_path__ + "static/media/Door-open-Event-Icon.8e930391a84eff39a0597ced54d55f97.svg";
export { ForwardRef as ReactComponent };